import React from 'react';

const BannerArticles = (props) => (
    <section id="banner" className="style2 articles major">
        <div className="inner">
            <header className="major">
                <h1>Articles</h1>
            </header>
            <div className="content">
                <p>Research articles, book reviews and public ethnography</p>
            </div>
        </div>
    </section>
);

export default BannerArticles;
